(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/poy-winners/assets/javascripts/poy-winners.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/poy-winners/assets/javascripts/poy-winners.js');
"use strict";


const _svs$poker_react$comp = svs.poker_react.components,
  PokerPaper = _svs$poker_react$comp.PokerPaper,
  PoyTable = _svs$poker_react$comp.PoyTable;
const PoyWinners = () => {
  const _svs$poker_react$data = svs.poker_react.data.poyWinConfig,
    winList = _svs$poker_react$data.winList,
    listHeader = _svs$poker_react$data.listHeader,
    numberOfPlayers = _svs$poker_react$data.numberOfPlayers;
  const playerList = winList.map((player, index) => ({
    value: player.win,
    name: player.name,
    rankingPos: index + 1
  }));
  return React.createElement("section", {
    className: "poy-winners-container f-content"
  }, React.createElement("h2", {
    id: "poy-winners-header"
  }, listHeader ? listHeader : 'Vinnare'), React.createElement(PokerPaper, null, React.createElement(PoyTable, {
    isCurrency: true,
    numberOfPlayers: numberOfPlayers,
    playerList: playerList
  })));
};
setGlobal('svs.poker_react.components.PoyWinners', PoyWinners);

 })(window);